// extracted by mini-css-extract-plugin
export default {"wrapper":"Toolbar_wrapper__wwbU+","newfeature":"Toolbar_newfeature__nfK4E","toolbarbutton":"Toolbar_toolbarbutton__4HtrG","toolbarbuttontitle":"Toolbar_toolbarbuttontitle__VkMNW"};